import { getApiClient } from "@/api/clientRegistry";
import {
  ExportReportResponse,
  generateMagicLinkReportPayload,
  generateSchoolReportPayload,
  SchoolBatchesResponse,
  SchoolStudentsResponse,
} from "@/types/school";

const geniusUrl = getApiClient("genius");

export const getSchoolBatches = async (schoolId: string) => {
  const response = await geniusUrl.get<SchoolBatchesResponse>(
    `/admin/schools/${schoolId}/batches`
  );
  return response.data;
};

export const getSchoolStudents = async (
  schoolId: string,
  params: { batch_ids: string[]; exam_date?: string }
) => {
  if (!schoolId.trim() || !params.batch_ids?.length) {
    return { students: [] } as SchoolStudentsResponse;
  }

  const response = await geniusUrl.get<SchoolStudentsResponse>(
    `/admin/schools/${schoolId}/students`,
    {
      params: {
        batch_ids: params.batch_ids,
        ...(params.exam_date ? { exam_date: params.exam_date } : {}),
      },
      paramsSerializer: { indexes: null },
    }
  );
  return response.data;
};

export const generateMagicLinkReport = async(schoolId: string, requestBody: generateMagicLinkReportPayload) => {
  const response = await geniusUrl.post(`/admin/schools/${schoolId}/magic-link-reports`,
    requestBody
  );
  return response.data;
};

export const exportMagicLinkReport = async (schoolId: string) => {
  const response = await geniusUrl.get<ExportReportResponse>(
    `/admin/schools/${schoolId}/magic-link-reports/download`
  );
  return response.data;
};

export const generateSchoolReport = async(schoolId: string, requestBody : generateSchoolReportPayload) => {
  const response = await geniusUrl.post(`/admin/schools/${schoolId}/exam-login-reports`,
    requestBody
  );
  return response.data;
};

export const exportSchoolReport = async (schoolId: string) => {
  const response = await geniusUrl.get<ExportReportResponse>(
    `/admin/schools/${schoolId}/exam-login-reports/download`
  );
  return response.data;
};